// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconFont_icon__30oyc"};